<p-toast />
<div class="container-fluid login-set">
  <div class="row login-row">
    <div class="col-lg-6 col-md-12 login-l">
      <div class="login-logo">
        <a href="/">
          <img src="assets/images/empower-logo.svg" />
        </a>
      </div>
      <div class="login-cm">
        <img src="assets/images/login-cm.png" />
      </div>
    </div>
    <div class="col-lg-6 col-md-12 login-r">
      <div class="login-logo">
        <a href="/">
          <img src="assets/images/empower-logo.svg" />
        </a>
      </div>
      <div class="login-section">
        <div class="row">
          <h2>LOGIN</h2>
          <form [formGroup]="signinForm" (ngSubmit)="onSubmit()">
            <div class="form-login">
              <div class="login-scroll">
                <div class="form-group">
                  <label for="username">Username</label>
                  <input
                    type="text"
                    formControlName="username"
                    class="form-control"
                    [ngClass]="{
                      'is-invalid':
                        signinForm.controls.username.touched &&
                        signinForm.controls.username.errors
                    }"
                  />
                  <div
                    *ngIf="
                      signinForm.controls.username.touched &&
                      signinForm.controls.username.errors
                    "
                    class="invalid-feedback"
                  >
                    <div
                      *ngIf="
                        signinForm.controls.username.touched &&
                        signinForm.controls.username.errors.required
                      "
                    >
                      Username is required
                    </div>
                  </div>
                </div>
                <div class="form-group relative">
                  <label for="password">Password</label>
                  <input
                    #passwordinput
                    type="password"
                    formControlName="password"
                    class="form-control"
                    [ngClass]="{
                      'is-invalid':
                        signinForm.controls.password.touched &&
                        signinForm.controls.password.errors
                    }"
                  />
                  <i
                    class="mb-4 pi pi-eye text-2xl text-muted-color cursor-pointer togglePassword"
                    (click)="changePasswordType(passwordinput)"
                  ></i>
                  <div
                    *ngIf="
                      signinForm.controls.password.touched &&
                      signinForm.controls.password.errors
                    "
                    class="invalid-feedback"
                  >
                    <div
                      *ngIf="
                        signinForm.controls.password.touched &&
                        signinForm.controls.password.errors.required
                      "
                    >
                      Password is required
                    </div>
                  </div>
                </div>
              </div>
              @if(invalidUserNameOrPassword) {
              <div style="color: #ffd687">Invalid Username or password.</div>
              }
              <div class="form-group">
                <div class="d-flex gap-2 jusify-space-between">
                  <div class="d-flex gap-1 align-items-center">
                    No Account?
                    <a [routerLink]="['/register']" class="btn btn-link"
                      >Register</a
                    >
                  </div>
                  <button
                    [disabled]="signinForm.invalid"
                    class="btn btn-primary"
                  >
                    Login
                  </button>
                </div>
                <img
                  *ngIf="loading"
                  src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
                />
              </div>
            </div>
          </form>
        </div>
      </div>
      <img src="assets/images/ap-bg.png" class="img-fluid login-bg-img" />
    </div>
  </div>
</div>
